import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Payment } from 'services/action';

import { Form } from 'ui/components';

const initialState = {
  nominal: 0,
};

export const FormPayment = ({ id, onSubmit, data }) => {
  const Dispatch = useDispatch();
  const StateForm = useSelector((state) => state?.Form);

  const [{ nominal }, setState] = React.useState(initialState);

  const handleSubmit = async (e) => {
    const payload = {
      nominal: nominal,
    };

    if (data) {
      const req = await Dispatch(Payment.$update(id, data?.id, payload));

      if (req?.message === 'success') {
        onSubmit();
      }
    } else {
      const req = await Dispatch(Payment.$create(id, payload));

      if (req?.message === 'success') {
        onSubmit();
      }
    }
  };

  React.useEffect(() => {
    if (!data) return;

    setState((prevState) => ({
      ...prevState,
      nominal: data?.nominal,
    }));
  }, [data]);

  return (
    <div className="row">
      <div className="col-md-12">
        <Form.Input
          required
          value={nominal}
          onChange={(e) => {
            setState((prevState) => ({
              ...prevState,
              nominal: e.target.valueNumber,
            }));
          }}
          type="number"
          label="Nominal"
          error={StateForm?.errors?.nominal}
        />
        <div className="d-flex flex-end justify-content-end">
          <button
            type="button"
            className={
              StateForm?.loading
                ? 'btn-loading mt-3 btn btn-primary'
                : 'mt-3 btn btn-primary'
            }
            onClick={handleSubmit}
            disabled={StateForm?.loading}
          >
            Simpan
          </button>
        </div>
      </div>
    </div>
  );
};
